import { StyledAttendance } from "../../../../styled/attendance";
import AttendanceContainer from "./attendanceContainer";

const AuthorizedAttendanceContainer = () => {
  return (
    <StyledAttendance.GridContainer container justifyContent="center">
      <StyledAttendance.FormContainer>
        <AttendanceContainer />
      </StyledAttendance.FormContainer>
    </StyledAttendance.GridContainer>
  );
};

export default AuthorizedAttendanceContainer;
